import { config } from 'app/config/config';
import { i18n } from 'app/i18n';
import { NavigationService } from 'app/service/navigation-service';

interface Breadcrumb {
    text: string;
    path: string;
}

interface Breadcrumbs {
    externalBreadcrumbs: Breadcrumb[];
    internalBreadcrumbs: Breadcrumb[];
}

export class BreadcrumbUtils {
    public static getBreadcrumbs = (path: string, hasAppointment: boolean): Breadcrumbs => ({
        externalBreadcrumbs: [
            {
                text: i18n.components.breadcrumb.home,
                path: config.HOME_PAGE_URL,
            },
        ],
        internalBreadcrumbs: BreadcrumbUtils.getInternalBreadcrumbs(path, hasAppointment),
    });

    public static getInternalBreadcrumbs = (path: string, hasAppointment: boolean): Breadcrumb[] => {
        const breadcrumbs = [
            {
                path: NavigationService.SUMMARY,
                text: i18n.components.breadcrumb.summary,
            },
            {
                path: hasAppointment
                    ? NavigationService.RESCHEDULE_TECHNICIAN
                    : NavigationService.UPDATE_ACTIVATION_DATE,
                text: i18n.components.breadcrumb.updateActivationDate,
            },
        ];

        const currentBreadcrumbIndex = breadcrumbs.findIndex((element) => element.path === path);

        return breadcrumbs.slice(0, currentBreadcrumbIndex + 1);
    };

    public static isFirstInternalBreadcrumb = (path: string, hasAppointment: boolean): boolean => {
        const internalBreadCrumb = BreadcrumbUtils.getInternalBreadcrumbs(path, hasAppointment);

        return internalBreadCrumb.length !== 0 && internalBreadCrumb[0].path === path;
    };

    public static getPreviousBreadcrumbPath = (path: string, breadcrumbs: Breadcrumb[]): string =>
        breadcrumbs[breadcrumbs.findIndex((breadcrumb) => breadcrumb.path === path) - 1].path;
}
